function getCookie(value: string): string {
  const re = new RegExp(`(?:(?:^|.*;\\s*)${value}\\s*\\=\\s*([^;]*).*$)|^.*$`)
  return decodeURIComponent(document.cookie.replace(re, '$1'))
}

export default {
  getCookie,
}
